module.exports = __webpack_public_path__ + "img/d.4f7e779e.jpg";